import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import Selectors from "../Selectors";
import ActionCreator from "../ActionCreator";
import Form from "./Form";
import * as Ant from "antd";

const Wrapper = styled.div``;

class ProfileForm extends React.Component {
  render() {
    let { profile, appActions } = this.props;
    if (!profile) {
      return null;
    }
    console.log("profile", profile);

    let generalForm = [
      { name: "name", type: "text", label: "你的名稱" },
      { name: "phone", type: "display", label: "聯絡電話" },
      { name: "address", type: "textarea", label: "聯絡地址" },
      { name: "email", type: "text", label: "電子信箱" },
    ];

    return (
      <Wrapper>
        <Form
          model={{
            fields: generalForm,
          }}
          instance={profile}
          fnUpdate={this._edit}
        />
        <Ant.Alert
          type="info"
          message="欲修改密碼請聯繫客服"
          style={{ marginBottom: 20 }}
          showIcon
        />
      </Wrapper>
    );
  }

  _edit = async values => {
    let { appActions } = this.props;
    try {
      await appActions.editMyProfile(values);
      Ant.message.success("修改成功！");
    } catch (error) {
      console.log(error);
      Ant.message.error("修改錯誤！");
    }
  };
}

export default connect(
  (state, ownProps) => ({
    profile: Selectors.getLoginUser(state),
  }),
  ActionCreator
)(ProfileForm);
